module.exports = __webpack_public_path__ + "static/media/Thought-leaders.3c63549e.jpg";